export default function HelpCentre() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Help Centre</h1>
          <p>
            Welcome to the LEGITIMATELY Help Centre. We're here to assist you
            with all your queries.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Popular Topics</h2>
              <ul>
                <li>Managing Your LEGITIMATELY Account</li>
                <li>Billing and Payments</li>
                <li>Technical Support</li>
                <li>Subscription Plans</li>
              </ul>
            </div>
            <div className="privacy_title">
              <h2>Contact Us</h2>
              <p>
                Need more help? Reach out via the Contact Us page or chat with
                our 24/7 support team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
